module.exports = __webpack_public_path__ + "img/juggernaut.b6d47291.png";